/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from "react"
import { useLocation } from "react-router"
import { emitter, Experiment } from "@marvelapp/react-ab-test"

export const TOUR_ROUTES = [
	"/xt4cxulp/games/16231",
	"/xt4cxulp/games/16232",
	"/xt4cxulp/games/52247",
]

const AB_EXCLUDE_ROUTES = TOUR_ROUTES
export const abTestShouldExclude = (path) => {
	if (!path) return false
	return !!AB_EXCLUDE_ROUTES.find((route) => path.includes(route))
}

export const abGetActiveVariant = (testName) => {
	let path = window.location.href.split("#")[1]
	if (abTestShouldExclude(path)) {
		return "A"
	}
	return emitter.getActiveVariant(testName)
}

export function GuardedExperiment(props) {
	let location = useLocation()
	if (abTestShouldExclude(location.pathname)) {
		return props.defaultComponent ? props.defaultComponent : null
	}
	return <Experiment {...props} />
}

export const useABTests = () => {
	// We should track new AB tests here
}